<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" #default="{ loading }">
    <div class="layout">

      <panel prompt="За последний год">
        <template #title>
          <div>
            Среднее время проведения конкурсов (суток)
          </div>
        </template>
        <template #content>
          <div v-if="loading">
            <chart-preloader class="mv5"/>
          </div>
          <div v-else class="layout-chart">
            <div class="mh2 mh4-l">
              <svg-plot :config="plotConfig">
                <svg-columns :series="series" />
              </svg-plot>
            </div>
            <div class="flex flex-column flex-row-l flex-wrap justify-center">
              <div v-for="(item, index) in legend" :key="index" class="f6 flex items-center mh2-l">
                <span class="square" :style="'background-color: ' + item.color + ';'"></span>
                <span class="ml2 text-label">{{ item.label }}</span>
              </div>
            </div>
          </div>
        </template>
      </panel>

      <div class="layout-cards">
        <text-card v-for="(measure, index) in getStats(loading)" :key="index" :loading="loading" :prompt="measure.prompt">
          <template #title>{{ measure.title }}</template>
          <template #subtitle>{{ measure.subtitle }}</template>
          <template #value>{{ measure.value }}</template>
          <template #unit>{{ measure.unit }}</template>
        </text-card>
      </div>

    </div>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import ChartPreloader from '@/components/ui/progress/ChartPreloader.vue'
import Panel from '@/components/dashboard/widgets/templates/Panel.vue'
import TextCard from '@/components/dashboard/widgets/templates/TextCard.vue'
import SvgPlot from '@/components/charts/svg/plot/Plot.vue'
import SvgColumns from '@/components/charts/svg/plot/Columns.vue'
import { senseMap } from '@/plugins/colors.js'
const moment = require('moment')

export default {
  components: {
    ReportDataProvider,
    ChartPreloader,
    Panel,
    TextCard,
    SvgPlot,
    SvgColumns
  },
  data () {
    return {
      requiredReports: ['tendersAvgTimeSpending', 'tendersAvgTimeDuration'],
      reports: null
    }
  },
  computed: {
    stats () {
      return [
        {
          title: 'Средняя длительность конкурсов',
          // subtitle: 'Cреднее время нахождения конкурсов от стадии "Открыт" до стадии "Закрыт"',
          subtitle: 'От стадии "Открыт" до стадии "Закрыт"',
          value: moment.duration(this.reports.tendersAvgTimeDuration.avg, 'days').humanize(),
          prompt: 'Среди закрытых на сегодня за последний год'
        },
        {
          title: 'Среднее время проведения конкурса',
          // subtitle: 'Cреднее время нахождения конкурсов в стадии "Открыт"',
          subtitle: 'В стадии "Открыт"',
          value: moment.duration(this.reports.tendersAvgTimeSpending.avg, 'days').humanize(),
          prompt: 'Среди закрытых на сегодня за последний год'
        }
      ]
    },
    series () {
      const { tendersAvgTimeDuration, tendersAvgTimeSpending } = this.reports
      return Array.from({ length: tendersAvgTimeDuration.byPeriod.length }, (v, i) => {
        const dur = tendersAvgTimeDuration.byPeriod[i]
        const spt = tendersAvgTimeSpending.byPeriod[i]
        return {
          x: i,
          columns: [
            {
              value: tendersAvgTimeDuration.byPeriod[i],
              color: senseMap.winner,
              label: dur === 0 ? '' : dur < 1 ? '0~1' : Math.floor(dur)
            },
            {
              value: tendersAvgTimeSpending.byPeriod[i],
              color: senseMap.incomplete,
              label: spt === 0 ? '' : spt < 1 ? '0~1' : Math.floor(spt)
            }
          ]
        }
      })
    },
    legend () {
      return [
        { label: 'Средняя длительность конкурсов', color: senseMap.winner },
        { label: 'Среднее время проведения конкурса', color: senseMap.incomplete }
      ]
    },
    plotConfig () {
      const { tendersAvgTimeDuration } = this.reports
      const labels = tendersAvgTimeDuration.byPeriod.map((_v, i) => ({ value: i, label: this.label(i) }))
      return {
        grid: {
          vertical: false,
          horizontal: false
        },
        axis: {
          x: labels,
          hidden: {
            y: true
          },
          windowSize: 10
        },
        spaces: {
          left: 0, right: 0, chartBottom: 20, top: 40
        }
      }
    }
  },
  methods: {
    label (offset) {
      return this.$store.getters['dashboard/label'](offset)
    },
    getStats (loading) {
      return loading ? [{}, {}] : this.stats
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-gap: .25rem;
  &-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: .25rem;
  }
  &-chart {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    grid-gap: 1rem;
    padding: 1rem 1rem 1rem 1rem;
    background-color: #FFFFFF;
  }
}
@media screen and (min-width: 30em) and (max-width: 80em) {
  .layout {
    grid-gap: .5rem;
    &-cards {
      grid-gap: .5rem;
    }
  }
}
@media screen and (min-width: 80em) {
  .layout {
    grid-gap: .5rem;
    &-cards {
      grid-gap: .5rem;
    }
  }
}
</style>
